<template>
	<DropdownMenuPicker
		class="component-dropdown-account-panel"
		popper-class="dropdown-account-panel-popper-class"
		width="320px"
		v-bind="$attrs"
		@show="getUserAssets"
	>
		<template v-if="$slots.default">
			<slot />
		</template>
		<template v-else>
			<SensorTrack
				:datas="{
					sensorEventName: 'PersonalCenter',
					button_name: '用户名',
				}"
			>
				<nuxt-link-enhance
          class="box-border flex items-center bm-size-3_5 cursor-pointer"
					project="www"
					to="/account"
					exact
				>
					<template v-if="avatar">
						<img class="avatar" :src="avatarUrl" />
					</template>
					<template v-else>
						{{ userName }}
					</template>
				</nuxt-link-enhance>
			</SensorTrack>
			<!-- @TODO 这里增加名字跳转 -->
		</template>
		<template #content>
			<div class="pt-3 pb-4">
				<!-- @TODO button组件需要提炼 -->
				<!-- pc端+大pad共用+小pad共用 -->
				<!-- @TODO 优化这里，loading -->
				<AccountOverviewCard class="px-4 py-4" :datas="assetsData" />
				<div class="flex flex-col py-1 border-0 border-t border-solid bm-bd-gray-200">
					<div
						:class="{
							'bm2xl:hidden': ['assets', 'orders'].indexOf(item.value) !== -1,
						}"
						v-for="item in $$AUTH_ROUTES_CONFIG"
						:key="item.value"
					>
						<SensorTrack :datas="item.sensorData" v-if="item.show">
							<nuxt-link-enhance
								class="box-border flex items-center px-4 py-3 bm-size-3_5 leading-6 cursor-pointer hover:bm-bg-gray-100"
								:project="item.project"
								:to="item.to"
								exact
							>
								{{ $t(item.name) }}
							</nuxt-link-enhance>
						</SensorTrack>
					</div>
				</div>
				<div class="py-1 border-0 border-t border-solid bm-bd-gray-200">
					<div
						class="box-border flex items-center px-4 py-3 bm-size-3_5 leading-6 cursor-pointer hover:bm-bg-gray-100"
						@click="$$logout"
					>
						<sensor-track
							:datas="{
								sensorEventName: 'ClickTopBar',
								module_name: '我的',
								button_name: '我的（退出登录）',
							}"
						>
							<span>{{ $t('bmui-navigator-bar.common_sign_out') }}</span>
						</sensor-track>
					</div>
				</div>
			</div>
		</template>
	</DropdownMenuPicker>
</template>

<script>
import commonMixins from '../mixins';
import SensorTrack from './SensorTrack';
import DropdownMenuPicker from './DropdownMenuPicker';
import AccountOverviewCard from './AccountOverviewCard';
import NuxtLinkEnhance from './NuxtLinkEnhance';
import { usePatchStore } from '~/common/js/patch';
import { isLoginedToken } from '~/common/js/utils';
import AvatarDarkImg from '../assets/avatar_dark.svg?url';
import AvatarLightImg from '../assets/avatar_light.svg?url';
import AvatarVipDarkImg from '../assets/avatar_vip_dark.svg?url';
import AvatarVipLightImg from '../assets/avatar_vip_light.svg?url';

export default {
	name: 'ComponentDropdownAccountPanel',
	components: {
		SensorTrack,
		DropdownMenuPicker,
		NuxtLinkEnhance,
		AccountOverviewCard,
	},

	mixins: [commonMixins],

	data() {
		return {
			showPrivate: false,
			assetsData: {},
			isLogined: false,
		};
	},
	props: {
		avatar: {
			type: Boolean,
			default: false,
		},
		theme: {
			type: String,
			default: '',
		},
	},
	computed: {
		locale() {
      return this.store.locale;
    },
    userName() {
      return this.store.account.userName;
    },
		agentType() {
			return this.store.account.agentType;
		},
		isVip() {
			return this.store.account.isVip;
		},
    canUseSubAccount() {
      return this.getters('account/canUseSubAccount');
    },
		avatarUrl() {
			if (this.isVip) {
				return this.theme === 'dark' ? AvatarVipDarkImg : AvatarVipLightImg;
			}
			return this.theme === 'dark' ? AvatarDarkImg : AvatarLightImg;
		},
	},

	methods: {
		getUserAssets() {
			if (!this.isLogined) {
				return;
			}
			this.$$getUserAssets().then((resData) => {
				if (!resData?.success) {
					return;
				}
				this.assetsData = resData.data;
			});
		},
	},
	mounted() {
		this.isLogined = isLoginedToken();
		// @TODO 这里需要再核对一下
		this.showPrivate = window.localStorage.getItem('showPrivate') === 'true';

		this.store.dispatch('account/getUserSecInfo');
		this.store.dispatch('account/getIsVip');
		setTimeout(() => {
			if (typeof this.agentType !== 'number') {
				this.store.dispatch('account/getIsAffiliate');
			}
		}, 500);

		// 预拉取一次数据
		this.getUserAssets();
	},
	setup() {
    const { store, getters } = usePatchStore();
    return {
      store,
      getters
    };
  }
};
</script>

<style lang="less" scoped>
@import '../assets/css/ui.variables.less';

.component-dropdown-account-panel {
	.avatar {
		width: 24px;
	}
}
</style>

<style lang="less">
.dropdown-account-panel-popper-class {
	min-width: 320px !important;
}
</style>
